// extracted by mini-css-extract-plugin
export default {"root":"LocateModal_root__hI4Nd"};